<template>
  <component :is="isPublicEventRoute ? 'div' : 'v-app'" id="tnmt" :class="{ 'tnm-public-app': isPublicEventRoute }">
    <component :is="isPublicEventRoute ? 'div' : 'v-main'">
      <router-view></router-view>
    </component>
  </component>
</template>

<script>
import { store } from './store'
import VApp from 'vuetify/lib/components/VApp'
import VMain from 'vuetify/lib/components/VMain'

export default {
  name: 'App',
  components: { VApp, VMain },

  data: () => ({
    // test: store,
  }),
  async mounted () {
    // console.log(this);
    // console.log(store)
    store.setReAauthRoute()
    // Lazy routes are not resolved yet when App first mounts.
    await new Promise(resolve => this.$router.onReady(resolve))
    if (!this.isPublicEventRoute) {
      await store.reAuth()
    }
    // console.log(this.store)
    /*
    if (this.store.user.state.isLoggedIn) {
      this.$router.push({name:'dashboard-overview'})
    } else {
      this.$router.push({name:'login'})
    }
    */
  },
  computed: {
    isPublicEventRoute () {
      return ['eventLanding', 'confirmParticipation'].includes(this.$route.name)
    },
    store () {
      return store
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
  .relative {
    position: relative
  }
  figure {
    img {
      max-width:100%!important;
    }
    &.image-style-align-right {
      float:right;
      padding-left:15px;
    }
    &.image-style-align-left {
      float:left;
      padding-right:15px;
    }
    &.image-style-align-center {
      left:0;
      right:0;
      margin: 0 auto;
    }
  }
</style>
